<mat-card-title>
  <div class="title-div-container">
    <button *ngIf="backLabel; else pageHeading" type="button" class="backBtn-flex" (click)="back.emit()">
      <fa-icon [icon]="backIcon" aria-hidden="true"></fa-icon>
      <span>{{ backLabel }}</span>
    </button>
    <ng-template #pageHeading>
      <h2 class="pageTitle">{{ pageTitle }}</h2>
    </ng-template>
    <div class="title-right-side" aria-label="Partner branding">
      <div class="pearsonLogo" role="img" aria-label="Pearson Evolution"></div>
      <mat-divider [vertical]="true" class="verticalDivider"></mat-divider>
      <div class="MSLogo" role="img" aria-label="Microsoft"></div>
      <mat-divider [vertical]="true" class="verticalDivider"></mat-divider>
      <div class="MCTLogo" role="img" aria-label="Microsoft Certified Trainer"></div>
    </div>
  </div>
</mat-card-title>